import { useState } from "react";
import GTextField from "../libs/textfield/GTextField";
import { combineClass } from "../libs/GWidget";

export default function RecipeSearch(props:{className:string}){
    const [search,setSearch] = useState<string>("")

    const onSearch = (e:any) => {
        setSearch(e.target.value)
    }
    return <div className={combineClass("search",props.className)}>
        <GTextField value={search} onChange={onSearch} placeholder="Search"/>
    </div>
}